/**
 * Returns the correct icon name for scoring types.
 */

const nonStandardIcons = {
	'number': 'unscored',
	'stabilize-number': 'unscored',
	'unscored-text': 'unscored-text',
	'scored-text': 'scored-text'
}

function scoringTypeIconOtions(type) {
	return type.standardScoringType || nonStandardIcons[type.kpiValueType]
}

export default scoringTypeIconOtions

scoringTypeIconOtions.__filename__ = 'components/scoring-type-icon.js'
